import { useBreadcrumb } from "features/breadcrumbs";
import TenantUsuarios from "../../Condominio/Detalhes/components/Usuarios";
import { useCurrentTenant } from "features/auth/tenant.store";
import { TipoTenantEnum } from "resources/enums/tenant";
// import { useRouteMatch } from "react-router-dom";
import { useMemo } from "react";
import Container from 'components/Container';

function UsuarioListagemPage() {
  const { tenant } = useCurrentTenant();
  // const route = useRouteMatch();

  const isCondominio = tenant.tipoTenantId === TipoTenantEnum.Condominio; // route.path.includes("responsaveis-legais");

  const breadcrumb = useMemo(() => {
    if (isCondominio) {
      return [{ name: "Responsáveis Legais" }];
    }

    return [{ name: "Usuários" }];
  }, [isCondominio]);

  useBreadcrumb(breadcrumb);

  return (
    <Container>
      <TenantUsuarios
        tipoTenantId={
          isCondominio
            ? TipoTenantEnum.Condominio
            : TipoTenantEnum.Administradora
        }
        tenantId={isCondominio ? tenant?.id : tenant.tenantPai?.id || tenant.id}
      />
    </Container>
  );
}

export default UsuarioListagemPage;
